/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { LocationDivisionBase } from "../../../../schema/generated/LocationDivision";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class LocationDivisionDataApi extends EntityDataApi<LocationDivisionBase> {
  public readonly def = idbEntityDefs.LocationDivision;
}